import { VisibilityResult } from "models/StatisticsReport";
import ProgressBar from "../Components/ProgressBar";

interface VisibilityProps {
    data: VisibilityResult[]
}

const Visibility = ({data}:VisibilityProps) => {

    const totalCompanyDisplayCount = new Intl.NumberFormat('nb-NO').format(data.reduce((total, item) => total + item.companyDisplayCount, 0));

    return (
        <div className="card mb-4">
            <div className="card-header">
                <div className="d-flex align-items-center">
                    <h2 className="p2"><big className="fw-bold">{totalCompanyDisplayCount}</big> visninger av din bedrift i søkeresultat</h2>
                </div>
            </div>
            <div className="card-body">
                <p className="text-muted mb-3"><small>Antall visninger av din bedrift / antall søk i din  bransje og område.</small></p>
                <div className="list-group">
                    {data.map((element) => {
                        return (
                            <div key={element.businessArea + "_" + element.tradeArea} className="list-group-item list-group-item-action">
                                <h5 className="fs-6">{element.businessArea} - {element.tradeArea}</h5>
                                <ProgressBar valueNow={element.companyDisplayCount} valueMin={0} valueMax={element.businessTotalDisplayCount} />
                                <small>{element.companyDisplayCount} / {element.businessTotalDisplayCount}</small>
                            </div>
                        )
                    })}
                </div>
                
            </div> 
        </div>
    );
}

export default Visibility;